import React, { useMemo } from 'react'
import styled from 'styled-components';
import {motion} from 'framer-motion';
import { useState } from 'react';
function DescImage({photoSource}) {


    
    const ImgWrapVariants = {
        initial:{
            width: "53%",
            height: "74%",
            margin: "0% 8% 0% auto"
        },
        animate:{
            width: "63%",
            height: "100%",
            margin: 0,
            transition: {
                type : "tween",
                duration: 0.5,
                delay: 0.3
            }
        },
        exit:{
            width: "53%",
            height: "74%",
            margin: "0% 8% 0% auto",
            transition: {
                type : "tween",
                duration: 0.5
            }
        }
    }
    const ImgWrapVariantsMobile = {
        initial:{
            width: "100%",
            height: "100%",
        },
        animate:{
            width: "100%",
            height: "60%",
            transition: {
                type : "tween",
                duration: 0.5,
                delay: 0.3
            }
        },
        exit:{
            width: "100%",
            height: "100%",
            transition: {
                type : "tween",
                duration: 0.5
            }
        }
    }
    
    const [variants, setVariants] = useState(ImgWrapVariants)
    useMemo(()=>{
        if(window.innerWidth<500) setVariants(ImgWrapVariantsMobile);
        else setVariants(ImgWrapVariants);
    },[]);
    
    return (
        <DescImgWrap
        variants={variants} initial='initial' animate='animate' exit='exit'
    >
        <div className='imagecontainer' >
            <img src={photoSource} alt="" />
            <div className="blue-filter"></div>
            <div className="red-filter"></div>
        </div>
    </DescImgWrap>
  )
}

const DescImgWrap = styled(motion.div)`
    position: relative;
    height: 100%;
    width: 63%;
    margin: 0% 0% 0% auto;
    pointer-events: none;
    box-shadow: 0px 7px 24px 11px #090d2c50;
    /* overflow: hidden; */
    
    .imagecontainer{ 
        position: relative;
        overflow: hidden;
        height: 100%;
        width: 100%;
    }

    img{
        width: 100%;
        height: 100%;    
        object-fit: cover;
    }

    .blue-filter{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--primary);
        transform: translate(105%, 0%);
    }
    .red-filter{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--secondary);
        transform: translate(105%, 0%);
    }

    @media only screen and (max-width: 500px){
        position: absolute;
        top: 0%;
        height: 70%;
        width: 63%;
        margin: 0;
    }

`;

export default DescImage